import { render, staticRenderFns } from "./tabHomeAddress.vue?vue&type=template&id=4e4ad242&scoped=true"
import script from "./tabHomeAddress.vue?vue&type=script&lang=js"
export * from "./tabHomeAddress.vue?vue&type=script&lang=js"
import style0 from "./tabHomeAddress.vue?vue&type=style&index=0&id=4e4ad242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4ad242",
  null
  
)

export default component.exports